import React from "react";
import DescribeImagePage from "../../components/DescribeImagePage";

export default function DescribeImage() {
  return <DescribeImagePage />;
}
